import KyleCVFile from "../../src/assets/files/KyleVeloso_CV.pdf"

function WebFooter() {
    return (
        <footer>
            <a className="link-button" href={KyleCVFile} download><i className="fa fa-download"></i> CV</a>
            <a href="https://www.github.com/revive-mejett" target="_blank" rel="noreferrer" className="link-button"><i className="fa fa-github"></i> revive-mejett</a>
            <a href="https://www.linkedin.com/in/kyle-veloso-b78647195/" target="_blank" rel="noreferrer" className="link-button"><i className="fa fa-linkedin"></i> Kyle Veloso</a>
        </footer>
    )
}

export { WebFooter }